/** Drops leading spaces. Keeps one trailing space so the next word can be typed. */
export function blockEdgeSpaces(value: string | undefined | null): string {
  if (typeof value !== "string") return "";
  return value.replace(/^\s+/, "").replace(/\s{2,}$/, " ");
}

/** True when Space would sit at the start, or add a second space at the end. */
export function isEdgeSpaceKey(
  key: string,
  value: string | undefined | null,
  selectionStart: number | null | undefined,
  selectionEnd: number | null | undefined,
): boolean {
  if (key !== " ") return false;
  const text = value ?? "";
  const start = selectionStart ?? 0;
  const end = selectionEnd ?? start;
  const before = text.slice(0, start);
  const after = text.slice(end);
  if (before.trim() === "") return true;
  return after === "" && /\s$/.test(before);
}

/** The input that received the key. The listener may sit on a wrapper. */
export function inputFromKeyEvent(event: {
  target: EventTarget | null;
}): HTMLInputElement | HTMLTextAreaElement | null {
  const target = event.target;
  if (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement
  ) {
    return target;
  }
  return null;
}
